import React from "react"
import Image from "../../static/media/Login.jpg"
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles((theme) => ({
  image: {
    backgroundImage: `url(${Image})`,
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? "white"
        : theme.palette.grey[900],
    backgroundSize: "contain",
    marginTop: 64,
    backgroundPosition: "top",
  }
}))

const LoginImage: React.FC = () => {
  const classes = useStyles();
  return (
    <Grid item xs={false} sm={false} md={7} className={classes.image} />
  )
}
export default LoginImage